import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_READJUSTMENT_INDICES](state, data) {
    state.allReadjustmentIndices = data
  },
  [types.SAVE_READJUSTMENT_INDICE](state, data) {
    state.allReadjustmentIndices.push(data)
  },
}
